// src/store.js (or wherever your store is)
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';    
import rootReducer from './reducers';

// If you want Redux DevTools with trace support:
const composeEnhancers =
  (typeof window !== 'undefined' &&
   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })) || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk)         // <-- add thunk here
  )
);

export default store;
